import OfferInclusionItem from 'components/Common/Inclusions/OfferInclusionItem'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Group from 'components/utils/Group'
import OfferPagePackageInclusionsList from '../OfferPagePackageInclusionsList'
import LoyaltyInclusions from 'loyalty/components/LoyaltyInclusions'

interface Props {
  inclusions: Array<App.PackageInclusion>
  bonusInclusions: Array<App.PackageInclusion>
  size?: 'small' | 'medium' | 'large'
  offer?: App.HotelOffer | App.VillaOffer
}

function InclusionsSection(props: Props) {
  const { inclusions, bonusInclusions, size = 'medium', offer } = props

  return <VerticalSpacer gap={12}>
    {!!bonusInclusions.length && <OfferPagePackageInclusionsList variant="bonus">
      {bonusInclusions.map((inclusion) => <OfferInclusionItem key={inclusion.id} inclusion={inclusion} size={size} />)}
    </OfferPagePackageInclusionsList>}
    <Group direction="vertical" gap={4}>
      <OfferPagePackageInclusionsList variant={bonusInclusions.length ? 'additional' : undefined}>
        {inclusions.map((inclusion) => <OfferInclusionItem key={inclusion.id} inclusion={inclusion} size={size} />)}
      </OfferPagePackageInclusionsList>
      <LoyaltyInclusions offer={offer} variant="offer-page" size={size} />
    </Group>
  </VerticalSpacer>
}

export default InclusionsSection
